module.exports = __webpack_public_path__ + "img/ic-location.7471fde5.svg";